import { keyBy, omit } from "lodash";

import {
  REQUEST_ADDRESSES_SUCCESS,
  REQUEST_ADDRESS_DETAILS_SUCCESS,
  CREATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_SUCCESS,
} from "../../constants/actionTypes";

const INITIAL_STATE = {
  addresses: {},
};

export default function addresses(state = INITIAL_STATE, action) {
  let { addresses = [], address = {} } = action?.payload || {};
  addresses = keyBy(addresses, "id");

  switch (action.type) {
    case REQUEST_ADDRESSES_SUCCESS:
      return {
        ...state,
        addresses,
      };

    case REQUEST_ADDRESS_DETAILS_SUCCESS: {
      // Merge a single address into the cache without dropping anything
      // already loaded by `requestAddresses`. Used to plug in addresses
      // that the bulk listing didn't return (uid-scoped query) but
      // which a quote/order references by id.
      if (!address?.id) return state;
      return {
        ...state,
        addresses: { ...state.addresses, [address.id]: address },
      };
    }

    case CREATE_ADDRESS_SUCCESS:
      const updatedAddresses = { ...state.addresses, [address?.id]: address };

      return {
        ...state,
        addresses: updatedAddresses,
      };

    case UPDATE_ADDRESS_SUCCESS:
      const afterUpdate = {
        ...state.addresses,
        [action?.payload?.id]: action?.payload?.data?.address,
      };

      return {
        ...state,
        addresses: afterUpdate,
      };

    case DELETE_ADDRESS_SUCCESS:
      const afterDelete = omit(state?.addresses, action?.payload?.id);

      return {
        ...state,
        addresses: afterDelete,
      };

    default:
      return state;
  }
}
